import React from 'react';

// One card in the "Today's Highlights" strip. Silent on error — highlights are
// curated; broken card = show fewer cards, not a broken one.
export default function HighlightsCard({ label, value, delta = null, caption, loading = false, error = null }) {
  if (error) return null;

  const isUp = Number.isFinite(delta) && delta > 0;
  const isDown = Number.isFinite(delta) && delta < 0;
  const deltaClass = isUp
    ? 'text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-950/30'
    : isDown
      ? 'text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-950/30'
      : 'text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-800/60';
  const deltaArrow = isUp ? '↑' : isDown ? '↓' : '';

  return (
    <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-5 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <div className="text-[11px] uppercase tracking-wider text-gray-500 dark:text-gray-400 font-semibold">{label}</div>
        {delta != null && Number.isFinite(delta) && (
          <div className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-md text-[11px] font-semibold ${deltaClass}`}>
            {deltaArrow}{Math.abs(delta).toFixed(1)}%
          </div>
        )}
      </div>
      {loading ? (
        <div className="animate-pulse space-y-2 py-1">
          <div className="h-8 w-24 rounded bg-gray-200 dark:bg-gray-800" />
          <div className="h-3 w-28 rounded bg-gray-200 dark:bg-gray-800" />
        </div>
      ) : (
        <>
          <div className="text-2xl font-bold text-gray-900 dark:text-gray-100 tabular-nums leading-tight">{value}</div>
          {caption && <div className="text-xs text-gray-500 dark:text-gray-400 mt-1.5">{caption}</div>}
        </>
      )}
    </div>
  );
}
